import { environment } from '../../../environments/environment';

function createUrl(actionName: string): string {
  return `${environment.apiBaseUrl}${environment.apiUrl}${environment.apiVersion}${actionName}`;
}

export const eventCalendarApiResources = {
  calendar: createUrl('calendar'),
  createCalendar: createUrl('calendar'),
  updateCalendar: createUrl('calendar'),
  removeCalendar: createUrl('calendar'),
  calendarCategories: createUrl('calendar-categories'),
  getCategoriesByCalendarId: createUrl('calendar-categories/by-calendar'),
  createCalendarCategory: createUrl('calendar-categories'),
  removeCalendarCategory: createUrl('calendar-categories'),
  updateCalendarCategory: createUrl('calendar-categories'),
  createCalendarEvents: createUrl('events'),
  getCalendarEvents: createUrl('events'),
  getCalendarGroups: createUrl('calendar-groups'),
  removeCalendarGroup: createUrl('calendar-groups'),
  createCalendarGroup: createUrl('calendar-groups'),
  updateCalendarGroup: createUrl('calendar-groups'),
  createCalendarDragAndDrop: createUrl('calendar/assign-to-group'),
  createEvent: createUrl('events'),
  getCalendarsWithEvents: createUrl('calendar/with/events'),
  deleteEvent: createUrl('events'),
  updateEvent: createUrl('events'),
  // GET events/{id} — single-event fetch by id (backend already has this
  // endpoint; no frontend wrapper existed for it before the Global Search
  // ?openEvent= deep link).
  getEventById: createUrl('events'),
  shareCalendar: createUrl('calendar'),
  getStaffListingWithSearch: createUrl('staff/search'),
  moveAppointment: createUrl('events'),
  deleteEventSlot: createUrl('events/slote'),
  getModuleWithEvents: createUrl('bids'),
  userCalendarSettings: createUrl('calendar/user/settings'),
  getDashboardScheduleEvents: createUrl('dashboard/schedule-events'),
  // Calendar event dialog uses this when the operator updates a
  // synthetic delivery event (id "delivery-N"). The generic
  // updateEvent path can't handle these — they have no row in the
  // events table — so the dialog routes here instead.
  rescheduleDelivery: createUrl('deliveries'),
};

export const permission = [
  {
    id: 1,
    title: 'view',
  },
  {
    id: 2,
    title: 'edit',
  },
];
